module.exports = __webpack_public_path__ + "img/home.94002615.jpg";